<template>
    <v-card class="pa-md-4">
            <v-card-title class="headline" style="word-break: break-word;">
                {{$t('credit_score.header')}}
            </v-card-title>
            <v-card-text class="pl-md-10 pr-md-10 pb-0 hidden-xs-only">
                <v-row>
                    <v-col cols="12" lg="7" md="12">
                        <p>
                             <span v-html="$t(`credit_score.status.${scoreStatus}`)"></span>
                        </p>
                        <p class="mt-8 caption">* {{$t('credit_score.own_model')}}</p>
                    </v-col>
                    <v-col cols="12" lg="4" md="12">
                        <div class="mt-n12">
                            <CreditScoreChart :score="user.credit_score" height="280px"></CreditScoreChart>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-text class="pl-md-10 pr-md-10 pb-0 hidden-sm-and-up">
                <v-row>
                    <v-col cols="12">
                        <div class="mt-n12">
                            <CreditScoreChart height="240px" :score="user.credit_score"></CreditScoreChart>
                        </div>
                    </v-col>
                    <v-col cols="12" class="pt-0">
                        <div class="mt-n3">
                            <div style="text-decoration: underline" class="text-center">
                                <span @click="scoreStatusHint()">
                                    <b>{{(user.credit_score ? user.credit_score : 0) + ' ' +  $t('credit_score.points')}}</b> - {{$t('credit_score.score_status_hint')}}
                                </span>
                            </div>
                            <div v-if="scoreStatusIsOpened" class="mt-3">
                                <span v-html="$t(`credit_score.status.${scoreStatus}`)"></span>
                            </div>
                        </div>

                    </v-col>
                    <v-col cols="12">
                        <p class="mt-n4 caption">* {{$t('credit_score.own_model')}}</p>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="creditScoreQuestions()">
                    {{user.credit_score ? $t('credit_score.change_answers') : $t('credit_score.get_rating')}}
                </v-btn>
            </v-card-actions>
            <div class="pa-4" v-if="user.credit_score">
                <OfferCards></OfferCards>
            </div>
        </v-card>
</template>

<script>
    import CreditScoreService from "../services/creditScoreService";
    import OfferCards from "../../../offers/shared/components/offerCards";
    import CreditScoreChart from '@/app/client/profile/shared/components/creditScoreChart';

    export default {
        name: 'CreditScoreTemplate',
        components: {
            CreditScoreChart,
            OfferCards
        },
        data() {
            return {
                scoreStatusIsOpened: false,
            }
        },
        computed: {
            user() {
                return this.$store.getters.AUTH_USER;
            },
            scoreStatus() {
                return this.user
                    ? CreditScoreService.status(this.user.credit_score)
                    : 'very_low';
            },
        },
        methods: {
            creditScoreQuestions() {
                this.$store.dispatch('OPEN_CREDIT_SCORE_MODAL', true)
            },
            scoreStatusHint() {
                this.scoreStatusIsOpened = !this.scoreStatusIsOpened;
            }
        }

    }
</script>
